import useSettingContext from './useSettingContext';

export default useSettingContext;
